import { CreditCard, Plus } from "lucide-react";

import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/shared/EmptyState";
import CartaoVisual from "./CartaoVisual";

// FIN-3 — CartoesGrid.
// Header + grid responsivo (1/2/3 cols) + empty state.

export default function CartoesGrid({
  creditCards,
  creditUsage,
  isLoading,
  onEditDates,
  onDelete,
  onTalk,
  onSeeTransactions,
  onCreate,
}) {
  // Lookup do uso por cartão pra passar pro CartaoVisual.
  const usageById = {};
  (creditUsage?.cards || []).forEach(c => { usageById[c.account_id] = c; });

  if (!isLoading && creditCards.length === 0) {
    return (
      <section data-testid="contas-cartoes">
        <header className="flex items-center justify-between mb-4">
          <h3 className="text-caption font-semibold uppercase text-foreground-muted" style={{ letterSpacing: "0.10em" }}>
            <CreditCard className="w-3.5 h-3.5 inline mr-1.5" aria-hidden="true" />
            Cartões de crédito
          </h3>
          {onCreate && (
            <Button variant="ghost" size="sm" onClick={onCreate} data-testid="contas-cartoes-create">
              <Plus className="w-3.5 h-3.5" /> Novo cartão
            </Button>
          )}
        </header>
        <Card variant="elevated" className="glass-card py-10 px-6" data-testid="contas-cartoes-empty">
          <EmptyState
            icon={CreditCard}
            title="Sem cartões cadastrados"
            description="Cadastre seus cartões pra acompanhar fatura, vencimento e uso de limite."
            action={onCreate ? (
              <Button variant="secondary" size="md" onClick={onCreate}>
                <Plus className="w-4 h-4" /> Cadastrar primeiro cartão
              </Button>
            ) : null}
          />
        </Card>
      </section>
    );
  }

  return (
    <section data-testid="contas-cartoes">
      <header className="flex items-center justify-between mb-4">
        <h3 className="text-caption font-semibold uppercase text-foreground-muted" style={{ letterSpacing: "0.10em" }}>
          <CreditCard className="w-3.5 h-3.5 inline mr-1.5" aria-hidden="true" />
          Cartões de crédito
        </h3>
        {onCreate && (
          <Button variant="ghost" size="sm" onClick={onCreate} data-testid="contas-cartoes-create">
            <Plus className="w-3.5 h-3.5" /> Novo cartão
          </Button>
        )}
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {creditCards.map(card => (
          <CartaoVisual
            key={card.id}
            account={card}
            usage={usageById[card.id]}
            onEditDates={onEditDates}
            onDelete={onDelete}
            onTalk={onTalk}
            onSeeTransactions={onSeeTransactions}
          />
        ))}
      </div>
    </section>
  );
}
